export default __webpack_public_path__ + "static/media/3-4.abfd280f.jpg";